export default "__VITE_ASSET__DTp7d8B4__"